import { render, staticRenderFns } from "./TicketsBlackhole.vue?vue&type=template&id=72d1d446&"
import script from "./TicketsBlackhole.vue?vue&type=script&lang=js&"
export * from "./TicketsBlackhole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports